import { render } from "./OnboardingEdition.vue?vue&type=template&id=7e3d06c5"
import script from "./OnboardingEdition.vue?vue&type=script&lang=js"
export * from "./OnboardingEdition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__